/**
 * 创建日期枚举
 */
export const DATE_ENUM_OPTION = [
  {
    label: '近3天',
    translateKey: "components:date.t1",
    value: 3,
  },
  {
    label: '近7天',
    translateKey: "components:date.t2",
    value: 7,
  },
  {
    label: '近两周',
    translateKey: "components:date.t3",
    value: 14,
  },
  {
    label: '近一个月',
    translateKey: "components:date.t4",
    value: 30,
  },
  {
    label: '近三个月',
    translateKey: "components:date.t5",
    value: 90,
  },
  {
    label: '近半年',
    translateKey: "components:date.t6",
    value: 180,
  },
]


export const DATE_ENUM_OPTION2 = [
  {
    label: '近7天',
    translateKey: "components:date.t2",
    value: 6,
  },
  {
    label: '近两周',
    translateKey: "components:date.t3",
    value: 13,
  },
  {
    label: '近一个月',
    translateKey: "components:date.t4",
    value: 29,
  },
  {
    label: '近三个月',
    translateKey: "components:date.t5",
    value: 89,
  },
  {
    label: '近半年',
    translateKey: "components:date.t6",
    value: 179,
  },
  {
    label: '近一年',
    translateKey: "components:date.t7",
    value: 364,
  },
]
